<div *ngIf="params">
    <input type="text" class="form-control form-control-sm" placeholder="Tier name..." [(ngModel)]="params.data.name"
    tabindex="{{params.rowIndex}}">
    <!-- {{params.data.name}} -->
    <!-- <div>{{params.data.name}}</div> -->
</div>